import { render, staticRenderFns } from "./TradingOrders.vue?vue&type=template&id=291d0a0c&scoped=true&"
import script from "./TradingOrders.vue?vue&type=script&lang=js&"
export * from "./TradingOrders.vue?vue&type=script&lang=js&"
import style0 from "./TradingOrders.vue?vue&type=style&index=0&id=291d0a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291d0a0c",
  null
  
)

export default component.exports